const Footer = () => {
    return (
      <div className="w-full py-2">
        <p className="text-center text-gray-500 text-base">
          © 2025 Built by Kedari Chowtoori
          <br />
        </p>
      </div>
    );
  };
  
  export default Footer;
